<template>
	<div :class="props.classes">
		<table class="width-100">
			<slot></slot>
		</table>
	</div>
</template>

<script setup lang="ts">
interface Props {
	classes?: string;
}

const props = withDefaults(defineProps<Props>(), {
	classes: ''
});
</script>
